import {Component, Input, Output, EventEmitter} from "@angular/core";
import {EventBus} from "../event/EventBus";
import {ComponentBase} from "../base/ComponentBase";
import {RaVersion} from "../services/configuration/ra.version";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";
import {AudioQueueEvent, InterruptAudio} from "../event/AudioQueueEvent";
import {AudioQueueItem, TranslateAudio} from "../services/audio-playback/audioqueue.item";

@Component({
    selector: "countdown",
    templateUrl: "./countdown.component.html",
    styleUrls: ["./countdown.component.scss"]
})
export class CountdownComponent extends ComponentBase {
    private static COUNTDOWN:number = 3;
    private timeInterval: any;
    private COUNTDOWN_ANIMATION_DURATION: number = 1200;
    public value:number = CountdownComponent.COUNTDOWN;
    public visible: boolean;
    public animationTimestamp: number;

    @Output() onFinished = new EventEmitter<boolean>();

    constructor(private eventBus:EventBus,
                private audioQueueService:AudioQueueService) {
        super("CountdownComponent");
    }

    private finishCountdownProcess(): void {
        this.visible = false;
        this.onFinished.emit(true);
        clearInterval(this.timeInterval);
        this.value =  CountdownComponent.COUNTDOWN;
    }

    @Input()
    set run(visible: boolean) {
        if (visible) {
            this.visible = visible;
            this.animationTimestamp = Date.now();

            // need to stop whatever is going on right now before you play the count-down
            this.audioQueueService.hardReset();
            this.eventBus.next(new AudioQueueEvent(
                [new AudioQueueItem("RA_STEP_2_03", TranslateAudio.YES, () => {
                    this.finishCountdownProcess();
                })], InterruptAudio.YES));

            this.timeInterval = setInterval(() => {
                this.value--;
                if (this.value <= 0) {
                    this.finishCountdownProcess();
                }
            }, this.COUNTDOWN_ANIMATION_DURATION);
        }
    }

}
